import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import CustomTable from "../../components/customTable/CustomTable";
import DateStartAndEndSame from "../../components/customTable/DateStartAndEndSame";
import { createMRTColumnHelper } from "material-react-table";
import Swal from "sweetalert2";
import axiosInstance from "../../utils/axiosInstance";


export default function PartnerTransactionTable({
  type,
  refinery,
  metaltype,
  partnerFilterType,
  region,
  state,
  city,
  pincode,
}) {
  const [data, setData] = useState({
    totalCount: 0,
    totalPreTaxAmount: 0,
    data: [],
  });

  const [data1, setData1] = useState([]);
  // console.log("data111111111111111111111111111111111111:::::::::::::::::::::::::::::::::::::::::::::::::::::::", data1)
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };

  // Construct dynamic params
  const params = {
    type,
    refinery,
    metaltype,
    startDate,
    endDate,
    partnerFilterType,
  };

  if (partnerFilterType === "region" && region) params.region = region;
  if (partnerFilterType === "city" && state && city) {
    // params.state = state;
    params.city = city;
  }
  if (partnerFilterType === "pincode" && pincode) params.pincode = pincode;

  // console.log("params:::::::::::::::::::::::::::", params);

  const fetchData = async () => {
    setLoading(true);
    try {
      if (!startDate || !endDate) return;

      const res = await axiosInstance.get(`/partnerdistributorreport`, {
        params,
        // headers,
      });
      // const res = await axios.get(`${baseUrl}/partnerdistributorreport`, {
      //   params,
      //   headers,
      // });

      setData({
        totalCount: res?.data?.totalCount,
        totalPreTaxAmount: res?.data?.totalPreTaxAmount,
        data: res?.data?.data || [],
      });

      setData1(res?.data?.partner_data);
      setLoading(false);

      // console.log("Fetched data:", res);
      if (res.data?.error === false) {
        // toast?.success(res?.data?.message || "Success");

        // Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: res?.data?.message || "Transaction successful",
        //   confirmButtonColor: "#3085d6",
        //   confirmButtonText: "OK",
        // });
      }
    } catch (err) {
      // console.error("Error fetching transactions:", err);
      if (err?.response && err?.response?.data) {
        // toast.error(err.response?.data?.message || "Failed to fetch transaction data");
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            err.response?.data?.message || "Failed to fetch transaction data",
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
      // toast.error("Failed to fetch transaction data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const shouldFetch = () => {
      if (!startDate || !endDate) return false;

      if (partnerFilterType === "region" && !region) return false;
      if (partnerFilterType === "city" && (!state || !city)) return false;
      if (partnerFilterType === "pincode" && !pincode) return false;

      return true;
    };

    if (shouldFetch()) {
      fetchData();
    } else {
      setData({ totalCount: 0, totalPreTaxAmount: 0, data: [] }); // Optional: clear old data
    }
  }, [
    type,
    refinery,
    metaltype,
    partnerFilterType,
    region,
    state,
    city,
    pincode,
    startDate,
    endDate,
  ]);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard!");
  };

  const handleDateSearch = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("client_id", {
      header: "Client ID",
      Cell: ({ row }) => (
        <Tooltip title={row.original?.client_id}>
          <span>
            <IconButton onClick={() => handleCopy(row.original?.client_id)}>
              <ContentCopy />
            </IconButton>
            {row.original?.client_id}
          </span>
        </Tooltip>
      ),
    }),
    columnHelper.accessor("partner_username", { header: "Username" }),
    columnHelper.accessor("client_name", { header: "Client Name" }),
    columnHelper.accessor("transaction_id", { header: "Transaction ID" }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 300,
      Cell: ({ row }) => (
        <Tooltip title={row.original?.merchantTransactionId}>
          <span>
            <IconButton
              onClick={() => handleCopy(row.original?.merchantTransactionId)}
            >
              <ContentCopy />
            </IconButton>
            {row.original?.merchantTransactionId}
          </span>
        </Tooltip>
      ),
    }),
    columnHelper.accessor("refinery", { header: "Refinery" }),
    columnHelper.accessor("metaltype", { header: "Metal Type" }),
    columnHelper.accessor("preTax", { header: "Pre-Tax" }),
    columnHelper.accessor("tax", { header: "Tax" }),
    columnHelper.accessor("totalAmount", { header: "Total Amount" }),
    columnHelper.accessor("pmt_type", { header: "Payment Type" }),
    columnHelper.accessor("pmt_status", { header: "Payment Status" }),
    columnHelper.accessor("KYC_status", { header: "KYC Status" }),
    columnHelper.accessor("type", { header: "Type" }),
    columnHelper.accessor("parter_region", { header: "Partner Region" }),
    columnHelper.accessor("partner_city", { header: "Partner City" }),
    columnHelper.accessor("createdAt", { header: "Transaction Date" }),
  ];
  const handleViewPartnerClick = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    // setData1(null);
  };
  return (
    <>
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "stretch", md: "center" }}
        justifyContent="space-between"
        gap={{ xs: 0, md: 2 }}
        flexWrap="wrap"
        width="100%"
      >
        {/* Left: Total Transactions and Amount */}
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          gap={{ xs: 0, sm: 2 }}
          width={{ xs: "100%", md: "auto" }}
        >
          {/* Total Transactions */}
          <Card sx={{ flex: 1 }}>
            <CardContent
              sx={{
                backgroundColor: "#4a2a7d",
                color: "#fff",
                height: { xs: 0, md: 80 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                // padding: { xs: "20px", md: "25px" },
                textAlign: "center",
              }}
            >
              <Typography variant="body2">
                Total Transactions: {data?.totalCount}
              </Typography>
            </CardContent>
          </Card>

          {/* Total Amount */}
          <Card sx={{ flex: 1 ,mt:{xs:-2,md:0}}}>
            <CardContent
              sx={{
                backgroundColor: "#4a2a7d",
                color: "#fff",
                height: { xs: 0, md: 80 },
                // height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                padding: "25px",
                textAlign: "center",
              }}
            >
              <Typography variant="body2">
                Total Amount Of Transactions:
                <br /> ₹ {data?.totalPreTaxAmount}
              </Typography>
            </CardContent>
          </Card>
        </Box>

        {/* Center: View Partner Button */}
        <Box
          display="flex"
          justifyContent={{ xs: "center", md: "center" }}
          width={{ xs: "100%", md: "auto" }}
        >
          <Card
            sx={{
              border: 0,
              boxShadow: "none",
              width: { xs: "100%", md: "auto" },
              mt:{xs:-1,md:0}
            }}
          >
            <CardContent
              sx={{
                color: "#fff",
                // height: { md: 80 },

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 0,
              }}
            >
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleViewPartnerClick}
                fullWidth={true}
                sx={{
                  backgroundColor: "#4a2a7d !important",
                  // fontWeight: "bold",
                  color: "#fff",
                  px: { xs: 0, md: 3 },
                  py: 1,
                  fontSize: { xs: "12px", md: "14px" },
                  "&:hover": {
                    backgroundColor: "#4a2a7d !important",
                  },
                }}
              >
                View Transaction Partner Wise
              </Button>
            </CardContent>
          </Card>
        </Box>

        {/* Right: Date Filter */}
        <Box
          display="flex"
          justifyContent={{ xs: "flex-start", md: "flex-end" }}
          alignItems="flex-start"
          width={{ xs: "100%", md: "auto" }}
          sx={{ mt: { xs: -3, md: -1 }, mb: { xs: 2, md: 1 } }}
        >
          <DateStartAndEndSame
            onSearch={handleDateSearch}
            defaultStartDate={startDate}
            defaultEndDate={endDate}
            sx={{ width: { xs: "100%", md: "auto" } }}
          />
        </Box>
      </Box>
      {/* <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "stretch", md: "center" }}
        justifyContent="space-between"

        gap={{ xs: 0, md: 2 }}
        flexWrap="wrap"
      >
        <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={{ xs: 0, md: 2 }}>
          <Card>
            <CardContent
              sx={{
                backgroundColor: "#4a2a7d",
                color: "#fff",
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                padding: "25px",
              }}
            >
              <Typography variant="body2" align="center">
                Total Transactions: {data?.totalCount}
              </Typography>
            </CardContent>
          </Card>

          <Card>
            <CardContent
              sx={{
                backgroundColor: "#4a2a7d",
                color: "#fff",
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                padding: "25px",
              }}
            >
              <Typography variant="body2" align="center">
                Total Amount Of Transactions:<br /> ₹ {data?.totalPreTaxAmount}
              </Typography>
            </CardContent>
          </Card>
        </Box>

        <Box display="flex" justifyContent="center">
          <Card
            sx={{
              border: 0,
              boxShadow: "none",
            }}
          >
            <CardContent
              sx={{
                color: "#fff",
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleViewPartnerClick}
                sx={{
                  backgroundColor: "#4a2a7d !important",
                  fontWeight: "bold",
                  color: "#fff",
                  padding: 2,
                  fontSize: "10px",
                  "&:hover": {
                    backgroundColor: "#4a2a7d !important",
                  },
                }}
              >
                View Transaction Partner Wise
              </Button>
            </CardContent>
          </Card>
        </Box>

        <Box
          display="flex"
          justifyContent={{ xs: "flex-start", md: "flex-end" }}
          alignItems="flex-start"
          sx={{ mt: -1, mb: 1 }}
        >
          <DateStartAndEndSame
            onSearch={handleDateSearch}
            defaultStartDate={startDate}
            defaultEndDate={endDate}
          />
        </Box>

      </Box> */}
      <CustomTable columns={columns} data={data?.data} loading={loading} permissionKey="DistributorReport"/>


      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md">
        <DialogTitle>Partner Transactions Reports</DialogTitle>
        <DialogContent dividers>
          {data1?.length === 1 || data1?.length === 2 ? (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: "center",
              }}
            >
              {data1.map((partner, index) => (
                <Card
                  key={index}
                  sx={{
                    backgroundColor: "#4a2a7d",
                    color: "black",
                    minWidth: 250,
                    flex: "1 1 auto",
                  }}
                >
                  <CardContent>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      User Name: {partner?.partnerusername}
                    </Typography>
                    <Typography variant="body2">
                      Trnx Count: {partner?.txcount}
                    </Typography>
                    <Typography variant="body2">
                      Trnx Amount: ₹{partner?.txamount}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          ) : data1?.length > 2 ? (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "1fr 1fr",
                  md: "1fr 1fr 1fr",
                },
                gap: 2,
              }}
            >
              {data1.map((partner, index) => (
                <Card
                  key={index}
                  sx={{
                    backgroundColor: "#4a2a7d",
                    color: "black",
                    minWidth: 200,
                  }}
                >
                  <CardContent>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      User Name: {partner?.partnerusername}
                    </Typography>
                    <Typography variant="body2">
                      Trnx Count: {partner?.txcount}
                    </Typography>
                    <Typography variant="body2">
                      Trnx Amount: ₹{partner?.txamount}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          ) : (
            <Typography>No Data</Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
